import styled from 'styled-components'
import { Dots } from '@brainhubeu/react-carousel'
import GridIcon from '../../images/ic-grid.svg'
import { breakpoints, Container } from '../../styles/global'

export const Wrapper = styled.div`
  position: absolute;
  background-color: white;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  z-index: 10;
  padding-top: 2em;
  padding-bottom: 2em;
`

export const IndicatorList = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 250px;
  margin: 0 auto;
  margin-top: 25px;
`

export const IndicatorItem = styled.span`
  height: 10px;
  width: 10px;
  border: 1px solid black;
  border-radius: 50%;
  background-color: ${props => (props.active ? 'black' : 'none')};
`

export const CarouselImage = styled.img`
  max-height: 50vh;

  @media (min-width: ${breakpoints.min.laptop}px) {
    max-height: 550px;
  }
  margin-top: auto;
  margin-bottom: auto;
`

export const Indicators = styled(Dots)``

export const Arrow = styled.img``

export const CarouselContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 80vh;
  ${'' /* height: 100%; */}
  padding-bottom: 100px;
  
  @media (min-width: ${breakpoints.min.tablet}px) {
    padding-bottom: 80px;
  }
  
  @media (min-width: ${breakpoints.min.laptop}px) {
    padding-bottom: 0; 
  }
`

export const ContentWrapper = styled(Container)`
  display: flex;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;

  @media (min-width: ${breakpoints.min.laptop}px) {
    bottom: 0;
  }
`

export const PaginationDots = styled.div`
  bottom: 100px !important;
  width: 100%;

  & .swiper-pagination-bullet {
    height: 2vw;
    width: 2vw;
    max-height: 13px;
    max-width: 13px;
    padding-left: 0.8vw;
    padding-right: 0.8vw;
    background: none;
    border: 1px solid black !important;
    opacity: 0.75;
  }

  & .swiper-pagination-bullet-active {
    background: black;
    opacity: 1;
  }
`

export const CarouselHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;
`

export const ToggleGridButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`

export const CarouselFooter = styled.div``

export const ActionButton = styled.button`
  background: none;
  border: none;
`


export const SwiperContainer= styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const SwiperSlide= styled.div`
 width:300px;
 height:300px;
`

export const SliderItem= styled.div`
 display: flex;
  justify-content: center;
`

export const ArrowsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 100;

  @media (max-width: 767px) {
    display: none;
  }
`

export const SliderArrow = styled.button`
  padding: 0;
  margin: 0;
  height: 50px;
  width: 50px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 10;
`

export const GridViewIcon = styled(GridIcon)`
  height: 15px;
  width: 15px;
  margin-left: 5px;
`


